import { useTheme } from "@mui/material"

export default function Payment({size = 20}) {
    const theme = useTheme();

    const baseWidth = 20;
    const baseHeight = 20;
  
    const height = (baseHeight * size) / baseWidth;

    return (
        <svg 
            width={baseWidth}
            height={height} 
            viewBox="0 0 20 20" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                d="M8.33333 13.332V11.6656M8.33333 11.6656V9.9987M8.33333 11.6656L10 11.6658M8.33333 11.6656L6.66667 11.6654M17.5 9.9987V9.33203C17.5 8.39861 17.5 7.9319 17.3183 7.57538C17.1586 7.26177 16.9036 7.00681 16.59 6.84702C16.2335 6.66536 15.7667 6.66536 14.8333 6.66536H2.5M17.5 9.9987V13.332M17.5 9.9987H15.8333C14.9128 9.9987 14.1667 10.7449 14.1667 11.6654C14.1667 12.5859 14.9128 13.332 15.8333 13.332H17.5M2.5 6.66536V13.9987C2.5 14.9321 2.5 15.3989 2.68166 15.7554C2.84144 16.0689 3.09641 16.3239 3.41002 16.4837C3.76653 16.6654 4.23325 16.6654 5.16667 16.6654H14.8333C15.7667 16.6654 16.2335 16.6654 16.59 16.4837C16.9036 16.3239 17.1586 16.0689 17.3183 15.7554C17.5 15.3989 17.5 14.9321 17.5 13.9987V13.332M2.5 6.66536V5.9987C2.5 5.06528 2.5 4.59856 2.68166 4.24205C2.84144 3.92844 3.09641 3.67347 3.41002 3.51369C3.76653 3.33203 4.23324 3.33203 5.16667 3.33203H12.3333C13.2667 3.33203 13.7335 3.33203 14.09 3.51369C14.4036 3.67347 14.6586 3.92844 14.8183 4.24205C15 4.59856 15 5.06528 15 5.9987V6.66536" 
                stroke={theme.palette.rgd.primary} 
                strokeWidth="2" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
        </svg>

    )
}